import React from 'react';

type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/**
 * Box drawing tool (PLAT-11289). A plain solid-stroke rectangle. The existing
 * `DashedRectIcon` / `DashedOutlineWithInnerRectIcon` are dashed crop and
 * safe-zone glyphs and already carry those meanings.
 */
const DrawRectangleIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = 'var(--text-secondary)',
    strokeWidth = '1.6',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <rect
        x="2.3"
        y="3.6"
        width="11.4"
        height="8.8"
        rx="1.2"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default DrawRectangleIcon;
